<template>
    <div class="inner-page-content">
        <public-title :title="options.title">
            <span class="sub">{{options.subTitle}}</span>
        </public-title>
        <div class="section">
            <div class="s-left">
                <p class="info" v-for="(item, idx) in options.infoList" :key="idx">
                    <span>{{item.infoTit}}:</span> {{item.information}}
                </p>
            </div>
            <div class="s-right">
                <el-button v-if="options.btnText" class="handle-btn" :type="options.btnType">{{options.btnText}}</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import PublicTitle from "@components/title";
export default {
    props: {
        options: {
            type: Object,
            default: {}
        }
    },
    components: {
        PublicTitle,
    },
};
</script>

<style lang="scss" scoped>
.section {
    @include flex-between;
    width: 1200px;
    margin: 30px auto 0;
    padding: 15px;
    box-shadow: 0 0 10px 2px rgba(0, 0, 0, .1);
    border-radius: 5px;

    .info {
        font-size: 14px;
        line-height: 30px;
        color: #666;
        
        span {
            color: $defaultColor;
        }
    }
}
</style>